import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported, logEvent } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyCWIpfScOgF_b0EwuG7p3wSC7LnG1x8kz4',
  authDomain: 'conube-web-site.firebaseapp.com',
  projectId: 'conube-web-site',
  storageBucket: 'conube-web-site.firebasestorage.app',
  messagingSenderId: '747075662401',
  appId: '1:747075662401:web:d3d06ce257ba01efe04cc0',
  measurementId: 'G-DNNNTM6QZP',
};

const app = initializeApp(firebaseConfig);

let analytics;

if (typeof window !== 'undefined') {
  isSupported().then((supported) => {
    if (supported) {
      analytics = getAnalytics(app);
    }
  });
}

export const tagsAnalytcs = {
  // Abrir Empresa
  btn_banner_abrir_desk_wpp: 'btn_banner_abrir_desk_wpp',
  btn_banner_abrir_desk_ligar: 'btn_banner_abrir_desk_ligar',
  btn_whats_icones_abrir_desk: 'btn_whats_icones_abrir_desk',
  btn_whats_icones_abrir_desk_form: 'btn_whats_icones_abrir_desk_form',
  btn_contrat1_abrir_online_desk: 'btn_contrat1_abrir_online_desk',
  btn_contrat1_abrir_online_desk_wpp: 'btn_contrat1_abrir_online_desk_wpp',
  btn_contrat1_abrir_online_desk_ligar: 'btn_contrat1_abrir_online_desk_ligar',
  btn_contrat1_abrir_digital_desk: 'btn_contrat1_abrir_digital_desk',
  btn_contrat1_abrir_digital_desk_wpp: 'btn_contrat1_abrir_digital_desk_wpp',
  btn_contrat1_abrir_digital_desk_ligar: 'btn_contrat1_abrir_digital_desk_ligar',
  btn_contrat1_abrir_private_desk: 'btn_contrat1_abrir_private_desk',
  btn_contrat1_abrir_private_desk_wpp: 'btn_contrat1_abrir_private_desk_wpp',
  btn_contrat1_abrir_private_desk_ligar: 'btn_contrat1_abrir_private_desk_ligar',
  btn_contrat2_abrir_online_desk: 'btn_contrat2_abrir_online_desk',
  btn_contrat2_abrir_online_desk_wpp: 'btn_contrat2_abrir_online_desk_wpp',
  btn_contrat2_abrir_online_desk_ligar: 'btn_contrat2_abrir_online_desk_ligar',
  btn_contrat2_abrir_digital_desk: 'btn_contrat2_abrir_digital_desk',
  btn_contrat2_abrir_digital_desk_wpp: 'btn_contrat2_abrir_digital_desk_wpp',
  btn_contrat2_abrir_digital_desk_ligar: 'btn_contrat2_abrir_digital_desk_ligar',
  btn_contrat2_abrir_private_desk: 'btn_contrat2_abrir_private_desk',
  btn_contrat2_abrir_private_desk_wpp: 'btn_contrat2_abrir_private_desk_wpp',
  btn_contrat2_abrir_private_desk_ligar: 'btn_contrat2_abrir_private_desk_ligar',
  btn_baixo_abrir_desk: 'btn_baixo_abrir_desk',
  btn_baixo_abrir_desk_wpp: 'btn_baixo_abrir_desk_wpp',
  btn_baixo_abrir_desk_ligar: 'btn_baixo_abrir_desk_ligar',

  btn_banner_abrir_mob_wpp: 'btn_banner_abrir_mob_wpp',
  btn_banner_abrir_mob_ligar: 'btn_banner_abrir_mob_ligar',
  btn_whats_icones_abrir_mob: 'btn_whats_icones_abrir_mob',
  btn_whats_icones_abrir_mob_form: 'btn_whats_icones_abrir_mob_form',
  btn_jornada_abrir_mob: 'btn_jornada_abrir_mob',
  btn_jornada_abrir_mob_wpp: 'btn_jornada_abrir_mob_wpp',
  btn_jornada_abrir_mob_ligar: 'btn_jornada_abrir_mob_ligar',

  btn_contrat_abrir_online_mob: 'btn_contrat_abrir_online_mob',
  btn_contrat_abrir_online_mob_wpp: 'btn_contrat_abrir_online_mob_wpp',
  btn_contrat_abrir_online_mob_ligar: 'btn_contrat_abrir_online_mob_ligar',
  btn_whats_abrir_online_mob: 'btn_whats_abrir_online_mob',
  btn_whats_abrir_online_mob_form: 'btn_whats_abrir_online_mob_form',
  btn_contrat_abrir_digital_mob: 'btn_contrat_abrir_digital_mob',
  btn_contrat_abrir_digital_mob_wpp: 'btn_contrat_abrir_digital_mob_wpp',
  btn_contrat_abrir_digital_mob_ligar: 'btn_contrat_abrir_digital_mob_ligar',
  btn_whats_abrir_digital_mob: 'btn_whats_abrir_digital_mob',
  btn_whats_abrir_digital_mob_form: 'btn_whats_abrir_digital_mob_form',
  btn_contrat_abrir_private_mob: 'btn_contrat_abrir_private_mob',
  btn_contrat_abrir_private_mob_wpp: 'btn_contrat_abrir_private_mob_wpp',
  btn_contrat_abrir_private_mob_ligar: 'btn_contrat_abrir_private_mob_ligar',
  btn_whats_abrir_private_mob: 'btn_whats_abrir_private_mob',
  btn_whats_abrir_private_mob_form: 'btn_whats_abrir_private_mob_form',

  btn_dep_abrir_mob: 'btn_dep_abrir_mob',
  btn_dep_abrir_mob_wpp: 'btn_dep_abrir_mob_wpp',
  btn_dep_abrir_mob_ligar: 'btn_dep_abrir_mob_ligar',

  btn_faq_abrir_mob: 'btn_faq_abrir_mob',
  btn_faq_abrir_mob_wpp: 'btn_faq_abrir_mob_wpp',
  btn_faq_abrir_mob_ligar: 'btn_faq_abrir_mob_ligar',

  // Trocar contador
  btn_banner_trocar_desk_wpp: 'btn_banner_trocar_desk_wpp',
  btn_banner_trocar_desk_ligar: 'btn_banner_trocar_desk_ligar',
  btn_whats_icones_trocar_desk: 'btn_whats_icones_trocar_desk',
  btn_whats_icones_trocar_desk_form: 'btn_whats_icones_trocar_desk_form',
  btn_contrat1_trocar_online_desk: 'btn_contrat1_trocar_online_desk',
  btn_contrat1_trocar_online_desk_wpp: 'btn_contrat1_trocar_online_desk_wpp',
  btn_contrat1_trocar_online_desk_ligar: 'btn_contrat1_trocar_online_desk_ligar',
  btn_contrat1_trocar_digital_desk: 'btn_contrat1_trocar_digital_desk',
  btn_contrat1_trocar_digital_desk_wpp: 'btn_contrat1_trocar_digital_desk_wpp',
  btn_contrat1_trocar_digital_desk_ligar: 'btn_contrat1_trocar_digital_desk_ligar',
  btn_contrat1_trocar_private_desk: 'btn_contrat1_trocar_private_desk',
  btn_contrat1_trocar_private_desk_wpp: 'btn_contrat1_trocar_private_desk_wpp',
  btn_contrat1_trocar_private_desk_ligar: 'btn_contrat1_trocar_private_desk_ligar',
  btn_contrat2_trocar_online_desk: 'btn_contrat2_trocar_online_desk',
  btn_contrat2_trocar_online_desk_wpp: 'btn_contrat2_trocar_online_desk_wpp',
  btn_contrat2_trocar_online_desk_ligar: 'btn_contrat2_trocar_online_desk_ligar',
  btn_contrat2_trocar_digital_desk: 'btn_contrat2_trocar_digital_desk',
  btn_contrat2_trocar_digital_desk_wpp: 'btn_contrat2_trocar_digital_desk_wpp',
  btn_contrat2_trocar_digital_desk_ligar: 'btn_contrat2_trocar_digital_desk_ligar',
  btn_contrat2_trocar_private_desk: 'btn_contrat2_trocar_private_desk',
  btn_contrat2_trocar_private_desk_wpp: 'btn_contrat2_trocar_private_desk_wpp',
  btn_contrat2_trocar_private_desk_ligar: 'btn_contrat2_trocar_private_desk_ligar',
  btn_baixo_trocar_desk: 'btn_baixo_trocar_desk',
  btn_baixo_trocar_desk_wpp: 'btn_baixo_trocar_desk_wpp',
  btn_baixo_trocar_desk_ligar: 'btn_baixo_trocar_desk_ligar',

  btn_banner_trocar_mob_wpp: 'btn_banner_trocar_mob_wpp',
  btn_banner_trocar_mob_ligar: 'btn_banner_trocar_mob_ligar',
  btn_whats_icones_trocar_mob: 'btn_whats_icones_trocar_mob',
  btn_whats_icones_trocar_mob_form: 'btn_whats_icones_trocar_mob_form',
  btn_queromigrar_trocar_mob: 'btn_queromigrar_trocar_mob',
  btn_queromigrar_trocar_mob_wp: 'btn_queromigrar_trocar_mob_wp',
  btn_queromigrar_trocar_mob_ligar: 'btn_queromigrar_trocar_mob_ligar',

  btn_contrat_trocar_online_mob: 'btn_contrat_trocar_online_mob',
  btn_contrat_trocar_online_mob_wpp: 'btn_contrat_trocar_online_mob_wpp',
  btn_contrat_trocar_online_mob_ligar: 'btn_contrat_trocar_online_mob_ligar',
  btn_whats_trocar_online_mob: 'btn_whats_trocar_online_mob',
  btn_whats_trocar_online_mob_form: 'btn_whats_trocar_online_mob_form',
  btn_contrat_trocar_digital_mob: 'btn_contrat_trocar_digita_mob',
  btn_contrat_trocar_digital_mob_wpp: 'btn_contrat_trocar_digita_mob_wpp',
  btn_contrat_trocar_digital_mob_ligar: 'btn_contrat_trocar_digita_mob_ligar',
  btn_whats_trocar_digital_mob: 'btn_whats_trocar_digita_mob',
  btn_whats_trocar_digital_mob_form: 'btn_whats_trocar_digita_mob_form',
  btn_contrat_trocar_private_mob: 'btn_contrat_trocar_private_mob',
  btn_contrat_trocar_private_mob_wpp: 'btn_contrat_trocar_private_mob_wpp',
  btn_contrat_trocar_private_mob_ligar: 'btn_contrat_trocar_private_mob_ligar',
  btn_whats_trocar_private_mob: 'btn_whats_trocar_private_mob',
  btn_whats_trocar_private_mob_form: 'btn_whats_trocar_private_mob_form',

  btn_dep_trocar_mob: 'btn_dep_trocar_mob',
  btn_dep_trocar_mob_wpp: 'btn_dep_trocar_mob_wpp',
  btn_dep_trocar_mob_ligar: 'btn_dep_trocar_mob_ligar',

  btn_faq_trocar_mob: 'btn_faq_trocar_mob',
  btn_faq_trocar_mob_wpp: 'btn_faq_trocar_mob_wpp',
  btn_faq_trocar_mob_ligar: 'btn_faq_trocar_mob_ligar',

  // Quanto Custa
  btn_banner_quanto_abrir_desk_wpp: 'btn_banner_quanto_abrir_desk_wpp',
  btn_banner_quanto_abrir_desk_ligar: 'btn_banner_quanto_abrir_desk_ligar',
  btn_banner_quanto_trocar_desk_wpp: 'btn_banner_quanto_trocar_desk_wpp',
  btn_banner_quanto_trocar_desk_ligar: 'btn_banner_quanto_trocar_desk_ligar',
  btn_whats_icones_quanto_abrir_desk: 'btn_ whats_icones_quanto_abrir_desk',
  btn_whats_icones_quanto_abrir_desk_form: 'btn_whats_icones_quanto_abrir_desk_form',

  btn_topo_quanto_abrir_mob: 'btn_topo_quanto_abrir_mob',
  btn_topo_quanto_abrir_mob_wpp: 'btn_topo_quanto_abrir_mob_wpp',
  btn_topo_quanto_abrir_mob_ligar: 'btn_topo_quanto_abrir_mob_ligar',

  // Fazer ainda
  btn_contrat1_quanto_online_desk: 'btn_contrat1_quanto_online_desk',
  btn_contrat1_quanto_online_desk_abrir_wpp: 'btn_contrat1_quanto_online_desk_abrir_wpp',
  btn_contrat1_quanto_online_desk_abrir_ligar: 'btn_contrat1_quanto_online_desk_abrir_ligar',
  btn_contrat1_quanto_online_desk_trocar_wpp: 'btn_contrat1_quanto_online_desk_trocar_wpp',
  btn_contrat1_quanto_online_desk_trocar_ligar: 'btn_contrat1_quanto_online_desk_trocar_ligar',

  btn_contrat1_quanto_digital_desk: 'btn_contrat1_quanto_digital_desk',
  btn_contrat1_quanto_digital_desk_abrir_wpp: 'btn_contrat1_quanto_digital_desk_abrir_wpp',
  btn_contrat1_quanto_digital_desk_abrir_ligar: 'btn_contrat1_quanto_digital_desk_abrir_ligar',
  btn_contrat1_quanto_digital_desk_trocar_wpp: 'btn_contrat1_quanto_digital_desk_trocar_wpp',
  btn_contrat1_quanto_digital_desk_trocar_ligar: 'btn_contrat1_quanto_digital_desk_trocar_ligar',

  btn_contrat1_quanto_private_desk: 'btn_contrat1_quanto_private_desk',
  btn_contrat1_quanto_private_desk_abrir_wpp: 'btn_contrat1_quanto_private_desk_abrir_wpp',
  btn_contrat1_quanto_private_desk_abrir_ligar: 'btn_contrat1_quanto_private_desk_abrir_ligar',
  btn_contrat1_quanto_private_desk_trocar_wpp: 'btn_contrat1_quanto_private_desk_trocar_wpp',
  btn_contrat1_quanto_private_desk_trocar_ligar: 'btn_contrat1_quanto_private_desk_trocar_ligar',

  btn_contrat2_quanto_online_desk: 'btn_contrat2_quanto_online_desk',
  btn_contrat2_quanto_online_desk_abrir_wpp: 'btn_contrat2_quanto_online_desk_abrir_wpp',
  btn_contrat2_quanto_online_desk_abrir_ligar: 'btn_contrat2_quanto_online_desk_abrir_ligar',
  btn_contrat2_quanto_online_desk_trocar_wpp: 'btn_contrat2_quanto_online_desk_trocar_wpp',
  btn_contrat2_quanto_online_desk_trocar_ligar: 'btn_contrat2_quanto_online_desk_trocar_ligar',

  btn_contrat2_quanto_digital_desk: 'btn_contrat2_quanto_digital_desk',
  btn_contrat2_quanto_digital_desk_abrir_wpp: 'btn_contrat2_quanto_digital_desk_abrir_wpp',
  btn_contrat2_quanto_digital_desk_abrir_ligar: 'btn_contrat2_quanto_digital_desk_abrir_ligar',
  btn_contrat2_quanto_digital_desk_trocar_wpp: 'btn_contrat2_quanto_digital_desk_trocar_wpp',
  btn_contrat2_quanto_digital_desk_trocar_ligar: 'btn_contrat2_quanto_digital_desk_trocar_ligar',

  btn_contrat2_quanto_private_desk: 'btn_contrat2_quanto_private_desk',
  btn_contrat2_quanto_private_desk_abrir_wpp: 'btn_contrat2_quanto_private_desk_abrir_wpp',
  btn_contrat2_quanto_private_desk_abrir_ligar: 'btn_contrat2_quanto_private_desk_abrir_ligar',
  btn_contrat2_quanto_private_desk_trocar_wpp: 'btn_contrat2_quanto_private_desk_trocar_wpp',
  btn_contrat2_quanto_private_desk_trocar_ligar: 'btn_contrat2_quanto_private_desk_trocar_ligar',

  btn_baixo_quanto_abrir_desk: 'btn_baixo_quanto_abrir_desk',
  btn_baixo_quanto_abrir_desk_wpp: 'btn_baixo_quanto_abrir_desk_wpp',
  btn_baixo_quanto_abrir_desk_ligar: 'btn_baixo_quanto_abrir_desk_ligar',

  // Quanto custa Mobile
  btn_banner_quanto_abrir_mob_wpp: 'btn_banner_quanto_abrir_mob_wpp',
  btn_banner_quanto_abrir_mob_ligar: 'btn_banner_quanto_abrir_mob_ligar',
  btn_banner_quanto_trocar_mob_wpp: 'btn_banner_quanto_trocar_mob_wpp',
  btn_banner_quanto_trocar_mob_ligar: 'btn_banner_quanto_trocar_mob_ligar',
  btn_whats_icones_quanto_abrir_mob: 'btn_ whats_icones_quanto_abrir_mob',
  btn_whats_icones_quanto_abrir_mob_form: 'btn_whats_icones_quanto_abrir_mob_form',

  btn_contrat_quanto_online_mob: 'btn_contrat_quanto_online_mob',
  btn_contrat_quanto_online_mob_abrir_wpp: 'btn_contrat_quanto_online_mob_abrir_wpp',
  btn_contrat_quanto_online_mob_abrir_ligar: 'btn_contrat_quanto_online_mob_abrir_ligar',
  btn_contrat_quanto_online_mob_trocar_wpp: 'btn_contrat_quanto_online_mob_trocar_wpp',
  btn_contrat_quanto_online_mob_trocar_ligar: 'btn_contrat_quanto_online_mob_trocar_ligar',

  btn_contrat_quanto_digital_mob: 'btn_contrat_quanto_digital_mob',
  btn_contrat_quanto_digital_mob_abrir_wpp: 'btn_contrat_quanto_digital_mob_abrir_wpp',
  btn_contrat_quanto_digital_mob_abrir_ligar: 'btn_contrat_quanto_digital_mob_abrir_ligar',
  btn_contrat_quanto_digital_mob_trocar_wpp: 'btn_contrat_quanto_digital_mob_trocar_wpp',
  btn_contrat_quanto_digital_mob_trocar_ligar: 'btn_contrat_quanto_digital_mob_trocar_ligar',

  btn_contrat_quanto_private_mob: 'btn_contrat_quanto_private_mob',
  btn_contrat_quanto_private_mob_abrir_wpp: 'btn_contrat_quanto_private_mob_abrir_wpp',
  btn_contrat_quanto_private_mob_abrir_ligar: 'btn_contrat_quanto_private_mob_abrir_ligar',
  btn_contrat_quanto_private_mob_trocar_wpp: 'btn_contrat_quanto_private_mob_trocar_wpp',
  btn_contrat_quanto_private_mob_trocar_ligar: 'btn_contrat_quanto_private_mob_trocar_ligar',
  btn_whats_quanto_online_mob: 'btn_whats_quanto_online_mob',
  btn_whats_quanto_online_mob_form: 'btn_whats_quanto_online_mob_form',
  btn_whats_quanto_digital_mob: 'btn_whats_quanto_digital_mob',
  btn_whats_quanto_digital_mob_form: 'btn_whats_quanto_digital_mob_form',
  btn_whats_quanto_private_mob: 'btn_whats_quanto_private_mob',
  btn_whats_quanto_private_mob_form: 'btn_whats_quanto_private_mob_form',

  btn_baixo_quanto_abrir_mob: 'btn_baixo_quanto_abrir_mob',
  btn_baixo_quanto_abrir_mob_wpp: 'btn_baixo_quanto_abrir_mob_wpp',
  btn_baixo_quanto_abrir_mob_ligar: 'btn_baixo_quanto_abrir_mob_ligar',

  // Home
  btn_whats_home_icones_desk: 'btn_whats_home_icones_desk',
  btn_whats_home_icones_desk_form: 'btn_whats_home_icones_desk_form',
  btn_whats_home_icones_mobile: 'btn_whats_home_icones_mobile',
  btn_whats_home_icones_mobile_form: 'btn_whats_home_icones_mobile_form',

  // Soluções
  btn_whats_solucoes_vantagens_desk: 'btn_whats_solucoes_vantagens_desk',
  btn_whats_solucoes_vantagens_desk_form: 'btn_whats_solucoes_vantagens_desk_form',

  // Footer
  btn_whats_quemsomos_rodape_mobile: 'btn_whats_quemsomos_rodape_mobile',
  btn_whats_quemsomos_rodape_mobile_form: 'btn_whats_quemsomos_rodape_mobile_form',

  btn_whats_quemsomos_rodape_desk: 'btn_whats_quemsomos_rodape_desk',
  btn_whats_quemsomos_rodape_desk_form: 'btn_whats_quemsomos_rodape_desk_form',

  btn_whats_solucoes_rodape_mobile: 'btn_whats_solucoes_rodape_mobile',
  btn_whats_solucoes_rodape_mobile_form: 'btn_whats_solucoes_rodape_mobile_form',

  btn_whats_solucoes_rodape_desk: 'btn_whats_solucoes_rodape_desk',
  btn_whats_solucoes_rodape_desk_form: 'btn_whats_solucoes_rodape_desk_form',

  btn_whats_home_rodape_mobile: 'btn_whats_home_rodape_mobile',
  btn_whats_home_rodape_mobile_form: 'btn_whats_home_rodape_mobile_form',

  btn_whats_home_rodape_desk: 'btn_whats_home_rodape_desk',
  btn_whats_home_rodape_desk_form: 'btn_whats_home_rodape_desk_form',

  btn_whats_rodape_quanto_mob: 'btn_whats_rodape_quanto_mob',
  btn_whats_rodape_quanto_mob_form: 'btn_whats_rodape_quanto_mob_form',
  btn_whats_rodape_quanto_desk: 'btn_whats_rodape_quanto_desk',
  btn_whats_rodape_quanto_desk_form: 'btn_whats_rodape_quanto_desk_form',

  btn_whats_rodape_trocar_mob: 'btn_whats_rodape_trocar_mob',
  btn_whats_rodape_trocar_mob_form: 'btn_whats_rodape_trocar_mob_form',
  btn_whats_rodape_trocar_desk: 'btn_whats_rodape_trocar_desk',
  btn_whats_rodape_trocar_desk_form: 'btn_whats_rodape_trocar_desk_form',

  btn_whats_rodape_abrir_mob: 'btn_whats_rodape_abrir_mob',
  btn_whats_rodape_abrir_mob_form: 'btn_whats_rodape_abrir_mob_form',
  btn_whats_rodape_abrir_desk: 'btn_whats_rodape_abrir_desk',
  btn_whats_rodape_abrir_desk_form: 'btn_whats_rodape_abrir_desk_form',

  btn_saida_quanto_wpp: 'btn_saida_quanto_wpp',
  btn_saida_quanto_ligar: 'btn_saida_quanto_ligar',

};

export function addTagFirebaseAnalytcs(title, description = '') {
  logEvent(analytics, title, description);
}
